// src/components/stats/SeasonStatsBar.jsx -- presentational current-season stat
// bar. Receives pre-computed rows ([{label,valueStr}] from getSeasonStatRows) and
// a season label (from deriveSeasonLabel). Single job: render the cells. No stat
// math, no role logic, no API calls (spec v1b-amendment §C). Renders nothing when
// there are no rows or no season label, so the caller needs no conditional wrap.

export default function SeasonStatsBar({ rows, seasonLabel }) {
  if (!rows || rows.length === 0 || !seasonLabel) return null;

  return (
    <div style={{ padding: '0 0 14px' }}>
      <div
        style={{
          fontSize: 10, fontWeight: 700, color: '#64748b',
          textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8,
        }}
      >
        {`${seasonLabel} Season`}
      </div>
      <div
        style={{
          display: 'flex', background: '#0b1626', border: '1px solid #1e293b',
          borderRadius: 10, overflow: 'hidden',
        }}
      >
        {rows.map((r, i) => (
          <div
            key={r.label}
            style={{
              flex: 1, padding: '8px 0', textAlign: 'center',
              borderRight: i === rows.length - 1 ? 'none' : '1px solid #1e293b',
            }}
          >
            <div style={{ fontSize: 15, fontWeight: 800, color: '#fff' }}>{r.valueStr}</div>
            <div
              style={{
                fontSize: 10, fontWeight: 700, color: '#94a3b8', marginTop: 2,
                textTransform: 'uppercase',
              }}
            >
              {r.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
